import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import AdminLayout from "./pages/admin/AdminLayout";
import BlogManagerPage from "./pages/admin/BlogManagerPage";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import InventoryPage from "./pages/admin/InventoryPage";
import LegalPage from "./pages/admin/LegalPage";
import MtnDataBundlesPage from "./pages/admin/MtnDataBundlesPage";
import OrdersPage from "./pages/admin/OrdersPage";
import TransactionsPage from "./pages/admin/TransactionsPage";
import UsersPage from "./pages/admin/UsersPage";
import EmailManagementPage from "./pages/admin/EmailManagementPage";
import AdminForgotPasswordPage from "./pages/adminAuth/AdminForgotPasswordPage";
import AdminLoginPage from "./pages/adminAuth/AdminLoginPage";
import AdminRegisterPage from "./pages/adminAuth/AdminRegisterPage";
import AdminResetPasswordPage from "./pages/adminAuth/AdminResetPasswordPage";
import AdminProtectedRoute from "./routes/AdminProtectedRoute";
import AdminPublicRoute from "./routes/AdminPublicRoute";

function App() {
  return (
    <Routes>
      <Route element={<AdminPublicRoute />}>
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/register" element={<AdminRegisterPage />} />
      </Route>

      <Route path="/admin/forgot-password" element={<AdminForgotPasswordPage />} />
      <Route path="/admin/reset-password" element={<AdminResetPasswordPage />} />

      <Route element={<AdminProtectedRoute />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="inventory" element={<InventoryPage />} />
          <Route path="mtn-bundles" element={<MtnDataBundlesPage />} />
          <Route path="transactions" element={<TransactionsPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="emails" element={<EmailManagementPage />} />
          <Route path="blog" element={<BlogManagerPage />} />
          <Route path="legal" element={<LegalPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/admin/login" replace />} />
    </Routes>
  );
}

export default App;
